module.exports = __webpack_public_path__ + "img/PADRES.b24d0f10.png";